import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { PropTypes } from 'prop-types';

import Roles from './Roles';
import Permissions from './Permissions';
import Users from './Users';
import MerchantAccount from './Merchants';
import DetailedView from './Merchants/DetailedView';
import UserMerchantAccount from './Users/UserMerchantAccounts';
import Processors from './Processors';
import ProcessorDetail from './Processors/ProcessorDetail';
import Profile from './Profile';
import MerchantBeneficiaries from './MerchantBeneficiaries';
import TransactionCharges from './TransactionCharges';
import Transactions from './Transactions';
import QueueMessages from './QueueMessage';
import CollectionTransactions from './Transactions/CollectionTransactions';
import PayoutTransactions from './Transactions/PayoutTransactions';
import SettlementTransactions from './Transactions/SettlementTransactions';
import ChargebackTransactions from './Transactions/ChargebackTransactions';
import DepositTransactions from './Transactions/DepositTransactions';
import RefundTransactions from './Transactions/RefundTransactions';
import WithdrawTransactions from './Transactions/WithdrawTransactions';
import TransferTransactions from './Transactions/TransferTransactions';
import Dashboard from './Dashboard';
import SettlementReports from './SettlementReports';
import ProcessingSummaries from './ProcessingSummaries';
import Events from './Events';
import Timelines from './Timelines';
import TimelineDetails from './Timelines/TimelineDetails';
import EventDetails from './Events/EventDetails';
import GatewayTransaction from './Gateway/Transactions';
import GatewayCallbacks from './Gateway/Callbacks';
import GatewaySuspiciousLogs from './Gateway/SuspiciousLogs';
import GatewayIpns from './Gateway/IPNs';
import GatewayTransactionDetail from './Gateway/Transactions/TransactionDetails';
import GatewayIpnDetails from './Gateway/IPNs/IpnDetails';

import {
  MERCHANT_ACCOUNTS,
  PERMISSIONS,
  ROLES,
  TRANSACTION_CHARGES,
  USERS,
  TRANSACTIONS,
  PROCESSORS,
  FDS_CARDS,
  SETTLEMENT_REPORTS,
  PROCESSING_SUMMARIES,
  MERCHANT_BENEFICIARIES,
  QUEUEMESSAGES,
  DATA_TRAFFIC_WEBSITES
} from '../constants/resources';
import Can from '../util/can';
import ErrorBoundary from '../components/common/ErrorBoundary';
import FdsCards from './Fds/Cards';
import TrafficWebsites from './TrafficWebsites';

const PermissionRoute = (props) => {
  const { resource } = props;
  return (
    <Can I="read" a={resource}>
      <Route {...props} />
    </Can>
  );
};

PermissionRoute.propTypes = {
  resource: PropTypes.string,
};

PermissionRoute.defaultProps = {
  resource: '',
};

const App = () => (
  <div className="gx-main-content-wrapper">
    <ErrorBoundary>
      <Switch>
        <PermissionRoute path="/roles" component={Roles} resource={ROLES} />
        <PermissionRoute path="/permissions" component={Permissions} resource={PERMISSIONS} />
        <PermissionRoute path="/users" component={Users} resource={USERS} />
        <PermissionRoute exact path="/settlement-reports" component={SettlementReports} resource={SETTLEMENT_REPORTS} />
        <PermissionRoute exact path="/merchant-accounts" component={MerchantAccount} resource={MERCHANT_ACCOUNTS} />
        <Route exact path="/merchant-accounts/:merchantId" component={DetailedView} />
        <Route exact path="/merchant-accounts/users/:userId" component={UserMerchantAccount} />
        <PermissionRoute exact path="/processing_summaries" component={ProcessingSummaries} resource={PROCESSING_SUMMARIES} />
        <PermissionRoute exact path="/processors" component={Processors} resource={PROCESSORS} />
        <PermissionRoute path="/processors/:id/:code" component={ProcessorDetail} resource={PROCESSORS} />
        <PermissionRoute path="/transaction_charges" component={TransactionCharges} resource={TRANSACTION_CHARGES} />
        <Route path="/profile" component={Profile} />
        <PermissionRoute exact path="/merchant-charges" component={MerchantBeneficiaries} resource={MERCHANT_BENEFICIARIES} />
        <PermissionRoute exact path="/transactions" component={Transactions} resource={TRANSACTIONS} />
        <PermissionRoute exact path="/chargeback-transactions" component={ChargebackTransactions} resource={TRANSACTIONS} />
        <PermissionRoute exact path="/collection-transactions" component={CollectionTransactions} resource={TRANSACTIONS} />
        <PermissionRoute exact path="/payout-transactions" component={PayoutTransactions} resource={TRANSACTIONS} />
        <PermissionRoute exact path="/settlement-transactions" component={SettlementTransactions} resource={TRANSACTIONS} />
        <PermissionRoute exact path="/deposit-transactions" component={DepositTransactions} resource={TRANSACTIONS} />
        <PermissionRoute exact path="/refund-transactions" component={RefundTransactions} resource={TRANSACTIONS} />
        <PermissionRoute exact path="/withdraw-transactions" component={WithdrawTransactions} resource={TRANSACTIONS} />
        <PermissionRoute exact path="/transfer-transactions" component={TransferTransactions} resource={TRANSACTIONS} />
        <PermissionRoute exact path="/fds-cards" component={FdsCards} resource={FDS_CARDS} />
        <PermissionRoute exact path="/traffic-websites" component={TrafficWebsites} resource={DATA_TRAFFIC_WEBSITES} />
        <PermissionRoute exact path="/queue-messages" component={QueueMessages} resource={QUEUEMESSAGES} />
        <Route exact path="/events" component={Events} />
        <Route exact path="/events/:eventId" component={EventDetails} />
        <Route exact path="/timelines" component={Timelines} />
        <Route exact path="/timelines/:timelineId" component={TimelineDetails} />
        <Route exact path="/gateway-transactions" component={GatewayTransaction} />
        <Route exact path="/gateway-transactions/:transactionId" component={GatewayTransactionDetail} />
        <Route exact path="/gateway-callbacks" component={GatewayCallbacks} />
        <Route exact path="/gateway-suspicious-logs" component={GatewaySuspiciousLogs} />
        <Route exact path="/gateway-ipns" component={GatewayIpns} />
        <Route exact path="/gateway-ipns/:serviceType/:ipnId" component={GatewayIpnDetails} />
        <Route path="/dashboard" component={Dashboard} />
      </Switch>
    </ErrorBoundary>
  </div>
);

App.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string,
  }),
};

App.defaultProps = {
  match: {},
};

export default App;
